export const GET_HISTORY_WEEKLY = 'GET_HISTORY_WEEKLY';
export const GET_WEEKLY = 'GET_WEEKLY';
export const GET_WEEKLY_LIST = 'GET_WEEKLY_LIST';
export const GET_WEEKLY_HISTORY_LIST = 'GET_WEEKLY_HISTORY_LIST';
export const WEEKLY_INFO = 'WEEKLY_INFO';
export const SAVE_WEEKLY = 'SAVE_WEEKLY';
export const RESET_WEEKLY = 'RESET_WEEKLY';
export const FILL_NEXT_WORK = 'FILL_NEXT_WORK';
export const SENT_WEEKLY = 'SENT_WEEKLY';
export const UPLOAD_IMAGES = 'UPLOAD_IMAGES';
export const GET_WEEKLY_STATISTICS_DATA = 'GET_WEEKLY_STATISTICS_DATA';
